import { Avatar } from '@material-ui/core';
import React from 'react';
import './OneStory.css';

 

const OneStory = ({ proImage, proName, postImage, key }) => {
  
    
    return (
       
        <div className={`oneStory ${!postImage && 'notShow'}`} 
                        style={{backgroundImage:`url( ${postImage})`,backgroundPosition:'center', backgroundSize:'cover'}}>
            <Avatar src={proImage} className='mt-3 ml-2 border border-info'/>
            <h5 className='faceName'>{proName}</h5>
        </div> 
       
    ); 
};   
 
export default OneStory; 